import script from "./customerAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./customerAddress.vue?vue&type=script&setup=true&lang=js"

import "./customerAddress.vue?vue&type=style&index=0&id=45b5c7c2&lang=less"

const __exports__ = script;

export default __exports__